module.exports = __webpack_public_path__ + "static/media/hotely-tb.e0ecdda5.png";